import React, { FunctionComponent, useCallback, useState } from "react";
import "../../../css/dialogs/built_to_not_built_confirmation_dialog.css";
import { Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel } from "@mui/material";
import useAvvirSelector from "../../services/component_helpers/component_effects/use_avvir_selector";
import { useDispatch } from "react-redux";
import updateElementsStatus from "../../actions/viewer_page/update_elements_status";
import { ApiBuiltStatus } from "avvir";
import { builtToNotBuiltConfirmationDialogDismissed } from "../../events/viewer/built_to_not_built_confirmation_dialog_dismissed";
import getSelectedElements from "../../services/getters/planned_building_element_getters/element_selection_getters/get_selected_elements";
import { getBuiltToNotBuiltConfirmationDialogOpen } from "../../services/getters/viewer_getters/get_built_to_not_built_confirmation_dialog_open";

const SKIP_DIALOG_KEY = "skipBuiltToNotBuiltConfirmationDialog";

export function isBuiltToNotBuiltConfirmationDialogDismissed() {
  const sessionValue = window.sessionStorage.getItem(SKIP_DIALOG_KEY);
  if (sessionValue != null && sessionValue.length > 0) {
    return sessionValue.toLowerCase().includes("t");
  }

  return false;
}

export const BuiltToNotBuiltConfirmationDialog: FunctionComponent<Record<string, never>> = function BuiltToNotBuiltConfirmationDialog() {
  const dispatch = useDispatch();
  const open = useAvvirSelector(getBuiltToNotBuiltConfirmationDialogOpen);
  const selectedElements = useAvvirSelector(getSelectedElements);
  const elementCount = selectedElements.length;
  const [dismissed, setDismissed] = useState(isBuiltToNotBuiltConfirmationDialogDismissed());

  const onClose = useCallback(() => {
    dispatch(builtToNotBuiltConfirmationDialogDismissed());
  }, [dispatch]);

  const onToggleDismissed = useCallback(() => {
    setDismissed(value => !value);
  }, []);

  const onUpdateStatus = useCallback(() => {
    window.sessionStorage.setItem(SKIP_DIALOG_KEY, dismissed ? "true" : "false");
    dispatch(updateElementsStatus(ApiBuiltStatus.NOT_BUILT));
    dispatch(builtToNotBuiltConfirmationDialogDismissed());
  }, [dismissed, dispatch]);

  return <Dialog className="BuiltToNotBuiltConfirmationDialog-dialog" open={open}>
    <DialogTitle>Update Element Status</DialogTitle>
    <DialogContent>
      <p>
      Are you sure you want to update the status of the {elementCount === 1 ? "selected element" : `${elementCount} selected elements`} from <b>Built</b> to <b>Not Built</b>?
      This action will delete all previous analyses and reduce trade progress for the {elementCount === 1 ? "affected element" : `${elementCount} affected elements`}.
      </p>
      <FormControlLabel control={<Checkbox value={dismissed} onClick={onToggleDismissed}/>} label="Don't show this again this session"/>
    </DialogContent>
    <DialogActions className="BuiltToNotBuiltConfirmationDialog-actions">
      <Button className="BuiltToNotBuiltConfirmationDialog-cancel" onClick={onClose}>Cancel</Button>
      <Button className="BuiltToNotBuiltConfirmationDialog-confirm" onClick={onUpdateStatus} color="primary" variant="contained">Update Status</Button>
    </DialogActions>
  </Dialog>;
}

export default React.memo(BuiltToNotBuiltConfirmationDialog);
